var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 194.1919 215.1343",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        isolation: isolate;\n      }\n\n      .cls-2 {\n        fill: #cfd4db;\n      }\n\n      .cls-3 {\n        fill: #42526e;\n      }\n\n      .cls-4 {\n        fill: #a5adba;\n        mix-blend-mode: multiply;\n      }\n\n      .cls-5 {\n        fill: #344563;\n      }\n\n      .cls-6 {\n        fill: #cce0ff;\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-8 {\n        fill: #5e6c84;\n      }\n\n      .cls-9 {\n        fill: #ffc400;\n      }\n\n      .cls-10, .cls-11 {\n        fill: none;\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n        stroke-width: 2px;\n      }\n\n      .cls-10 {\n        stroke: #344563;\n      }\n\n      .cls-11 {\n        stroke: #5e6c84;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 407.8872,
    y1: 212.9394,
    x2: 576.4346,
    y2: 212.9394,
    gradientTransform: "translate(-468.6547 54.6728) rotate(-13.7976)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6908,
    stopColor: "#fff",
    stopOpacity: 0.1
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Search Error") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Objects"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M131.1125,162.4558l-9.8878-5.9888-8.3292,13.7519,9.8878,5.9888a15.603,15.603,0,0,1,5.88,6.3835h0a15.603,15.603,0,0,0,5.88,6.3835l40.1143,24.2964a12.8664,12.8664,0,0,0,17.6709-4.34h0a12.8664,12.8664,0,0,0-4.34-17.6709l-40.1143-24.2964a15.603,15.603,0,0,0-8.3812-2.2542h0A15.603,15.603,0,0,1,131.1125,162.4558Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_",
    "data-name": "<Path>",
    className: "cls-3",
    d: "M131.1125,162.4558l-3.0118-1.8242A8.0388,8.0388,0,0,0,117.06,163.343h0a8.0388,8.0388,0,0,0,2.7113,11.0405l3.0118,1.8242a15.603,15.603,0,0,1,5.88,6.3835h0a15.603,15.603,0,0,0,5.88,6.3835l40.1143,24.2964a12.8664,12.8664,0,0,0,17.6709-4.34h0a12.8664,12.8664,0,0,0-4.34-17.6709l-40.1143-24.2964a15.603,15.603,0,0,0-8.3812-2.2543h0A15.603,15.603,0,0,1,131.1125,162.4558Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M139.1437,164.7043a15.5973,15.5973,0,0,1-8.0312-2.2485l-3.0118-1.8242a8.0388,8.0388,0,1,0-8.3292,13.7518l3.0118,1.8242a15.597,15.597,0,0,1,5.7069,6.0648,67.8481,67.8481,0,0,0,10.6536-17.5681Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Compound_Path_",
    "data-name": "<Compound Path>",
    className: "cls-5",
    d: "M83.2537,200.0811a67.2348,67.2348,0,0,1-32.07-130.5894l.0007,0a66.7962,66.7962,0,0,1,50.8666,7.7861h0A67.2346,67.2346,0,0,1,83.2537,200.0811ZM55.0108,85.0726A51.1916,51.1916,0,1,0,93.739,91.0011h0A50.853,50.853,0,0,0,55.0108,85.0726Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_2",
    "data-name": "<Path>",
    className: "cls-6",
    d: "M23.439,108.2733a51.1908,51.1908,0,0,0,87.571,53.0407,51.1908,51.1908,0,0,0-87.571-53.0407Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M79.433,184.5071a51.2162,51.2162,0,0,0,38.9911-49.945,49.1261,49.1261,0,0,1-5.0867,2.2789c-15.7029,5.961-29.6895,2.11-36.4987.1308-20.4307-5.9389-24.79-17.3785-39.0414-24.5822a48.31,48.31,0,0,0-14.0939-4.53c-.0862.1394-.1793.2729-.2643.4134a51.1908,51.1908,0,0,0,55.994,76.2338Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_Path_3",
    "data-name": "<Path>",
    className: "cls-8",
    points: "94.203 120.575 83.035 109.606 67.78 125.138 52.248 109.883 41.279 121.05 56.811 136.306 41.555 151.838 52.723 162.807 67.979 147.275 83.511 162.53 94.48 151.363 78.947 136.107 94.203 120.575"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M77.5751,29.402,67.4051.4513a.6746.6746,0,0,0-1.3065.1453l-3.28,28.0575-6.4848-.7582a.6746.6746,0,0,0-.7148.8936L65.7888,57.74a.6746.6746,0,0,0,1.3065-.1453l3.28-28.0575,6.4848.7582A.6746.6746,0,0,0,77.5751,29.402Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M45.5707,47.7984,32.9283,39.1672a.2965.2965,0,0,0-.4249.3916l6.9523,12.2117-2.8407,1.6173a.2965.2965,0,0,0-.02.5025l12.642,8.6312a.2965.2965,0,0,0,.4249-.3916L42.7091,49.9183,45.55,48.3009A.2965.2965,0,0,0,45.5707,47.7984Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M99.593,36.046c-.6949,2.0742-9.7432-.957-10.4381,1.1173s8.3536,5.1049,7.6589,7.1785-9.7431-.9573-10.4379,1.1166c-.6954,2.0757,8.3529,5.107,7.6575,7.1827s-9.7442-.9541-10.44,1.1231S91.9459,58.8726,91.25,60.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M120.82,59.72c-1.5982,1.4937-7.8582-5.2045-9.4564-3.7108s4.6613,8.1922,3.0627,9.6863-7.8577-5.2049-9.4555-3.7117c-.7418.6933.2075,2.5062,1.2789,4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M16.1162,59.8606c2.1714.2657,1.0579,9.3658,3.2293,9.6315s3.2853-8.8344,5.4572-8.5687,1.0573,9.3657,3.2281,9.6313c1.0078.1233,1.7877-1.7687,2.5511-3.8063"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchError);
export default __webpack_public_path__ + "static/media/search-error.1b9023bf363da4814b8ac6bcf4b18790.svg";
export { ForwardRef as ReactComponent };